module.exports = __webpack_public_path__ + "static/media/DINE-IN.c4dd4395.svg";